export const COMPANY_DETAILS = {
  name: "Zarko Sportswear",
  address: "Motra, Sialkot, 51040, Pakistan",
  phone: "+92 310 5464116",
  whatsapp: "+92 303 9200750",
  shippingRegion: "USA, UK, and Worldwide",
  email: "zarkosportswear@gmail.com"
};
